import { rappiServices } from 'api';
import { AxiosRequestConfig } from 'axios';

export interface CreateWhatsAppOTP {
  phone: string;
  country_code: string;
}

export interface ValidateWhatsAppOTP {
  phone: string;
  country_code: string;
  code: string;
}

export interface AuthWhatsAppOTP {
  accessToken: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  name?: string;
  gender?: string;
  replacement_criteria_id: string;
  scope: string;
  social_id: string;
  global_phone_number: string;
  sms_code?: string;
  validate_code: boolean;
  phone: string;
  country_code: string;
}

export interface AuthOTPHeaders {
  'x-two-factor-auth': string;
  'x-two-factor-code': string;
}

export interface CreateWhatsAppOTPResponse {
  success: boolean;
  uuid: string;
  seconds_to_expire: string;
}

export interface ValidateWhatsAppOTPResponse {
  success: boolean;
}

export interface AuthWhatsAppOTPResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  refresh_token: string;
  first_login: boolean;
}

export interface CreateSMSOTP {
  phone: string;
  country_code: string;
  via: 'sms';
  locale: string;
}

export interface ValidateSMSOTP {
  phone: string;
  country_code: string;
  code: string;
  uuid: string;
}

export interface AuthSMSOTP {
  phone: string;
  social_id: string;
  accessToken: string;
  scope: string;
  country_code: string;
}

export interface CreateSMSOTPResponse {
  status: string;
  sid: string;
  message: string;
  seconds_to_expire: number;
}

export interface ValidateSMSOTPResponse {
  sid: string;
  status: string;
  valid: boolean;
}

export interface AuthSMSOTPResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  refresh_token: string;
  first_login: boolean;
}

export interface AuthOTPHeaders {
  'x-two-factor-auth': string;
  'x-two-factor-code': string;
}

export const sendWhatsAppOTP = (otp: CreateWhatsAppOTP): Promise<CreateWhatsAppOTPResponse> =>
  rappiServices
    .post<CreateWhatsAppOTPResponse>(
      '/rappi-authentication/login/whatsapp/create',
      {
        ...otp,
      },
      { noAuth: true } as AxiosRequestConfig,
    )
    .then((response) => response.data);

export const validateWhatsAppOTP = (otp: ValidateWhatsAppOTP): Promise<ValidateWhatsAppOTPResponse> =>
  rappiServices
    .post<ValidateWhatsAppOTPResponse>(
      'rappi-authentication/login/whatsapp/validate',
      {
        ...otp,
      },
      { noAuth: true } as AxiosRequestConfig,
    )
    .then((response) => response.data);

export const authenticateWhatsAppOTP = (
  otpAuth: AuthWhatsAppOTP,
  headers?: AuthOTPHeaders,
): Promise<AuthWhatsAppOTPResponse> =>
  rappiServices
    .post<AuthWhatsAppOTPResponse>('login/whatsapp', { ...otpAuth }, { noAuth: true, headers } as AxiosRequestConfig)
    .then((response) => response.data);

export const sendSMSOTP = (otp: CreateSMSOTP): Promise<CreateSMSOTPResponse> =>
  rappiServices
    .post<CreateSMSOTPResponse>('twilio-auth/verification-code/v2/send', otp, { noAuth: true } as AxiosRequestConfig)
    .then((response) => response.data);

export const validateSMSOTP = (otp: ValidateSMSOTP): Promise<ValidateSMSOTPResponse> =>
  rappiServices
    .get<ValidateSMSOTPResponse>('twilio-auth/verification-code/v2/check', {
      params: otp,
      noAuth: true,
    } as AxiosRequestConfig)
    .then((response) => response.data);

export const authenticateSMSOTP = (otpAuth: AuthSMSOTP, headers?: AuthOTPHeaders): Promise<AuthSMSOTPResponse> =>
  rappiServices
    .post<AuthSMSOTPResponse>('rocket/login/twilio/application_user', otpAuth, {
      noAuth: true,
      headers,
    } as AxiosRequestConfig)
    .then((response) => response.data);

export const resendTwoFactor = (key: string) =>
  rappiServices.post(
    '/ms/notify/update-code',
    { key },
    { headers: { 'x-two-factor-auth': key, 'x-two-factor-code': null } },
  );
